import { render } from "./search-form.vue?vue&type=template&id=ff1516a0"
import script from "./search-form.vue?vue&type=script&lang=js"
export * from "./search-form.vue?vue&type=script&lang=js"

import exportComponent from "/home/djordje/code/uwp/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__